import ShowCampaign from '../../pages/mailcoach/ShowCampaign';
export default [
  {
    path: '/v2/admin/email-campaigns/:campaignID(\\d+)',
    name: 'admin.mailcoach.campaign.show',
    component: ShowCampaign,
    meta: {
      title: 'Campaign',
    },
  },
]
